const GOODHABITZ_PROVIDER = 'GOODHABITZ';

export function goodHabitzCourseCount(goal: {
	checklistItems?: Array<{
		learningCourse?: { provider?: string | null } | null;
	}> | null;
}): number {
	return (
		goal.checklistItems?.filter((item) => item.learningCourse?.provider === GOODHABITZ_PROVIDER)
			.length ?? 0
	);
}
